var dispatcher = require("../dispatcher");
var axios = require('axios');
var constants = require("../constants/constants");
var EventEmitter = require('events').EventEmitter;
var em = new EventEmitter();

function TransportVehicleStore() {
    var listener = [];
    var Vehicle = [];
    var vehicles = [];

    function getVehicleInfo() {
        return vehicles;
    }

    //Add Vehicle
    function addVehicle(vehicle) {
        var user = JSON.parse(sessionStorage.getItem("User"));
        axios.post(constants.config.HOST + constants.api.POST_VEHICLE_INFO, {
            VehicleTypesID: vehicle.GadiPrakar,
            VehicleNo: vehicle.GadiNo,
            Passingdate: vehicle.GadiPassinDate,
            InsurancceCompanyName: vehicle.VimaCompanyName,
            InsurancceStartDate: vehicle.VimaStartDate,
            InsurancceEndDate: vehicle.VimaVedhataDate,
            PolicyNo: vehicle.VimaPolicyNo,
            CompanyId: vehicle.CompanyId, YearId: user.TargetYearId, TransportersId: user.TransportersId
        }).then(function (response) {
            console.log(response);
            em.emit('vehicles');
        }).catch(function (error) {
            console.log(error);
        })
    }

    function UpdateVehicle(VehicleInfo) {
        var user = JSON.parse(sessionStorage.getItem("User"));
        axios.put(constants.config.HOST + constants.api.PUT_VEHICLE_INFO, {
            Transport_VehiclesId: VehicleInfo.Transport_VehiclesId,
            VehicleTypesID: VehicleInfo.GadiPrakar,
            VehicleNo: VehicleInfo.GadiNo,
            Passingdate: VehicleInfo.GadiPassinDate,
            PolicyNo: VehicleInfo.VimaPolicyNo,
            InsurancceCompanyName: VehicleInfo.VimaCompanyName,
            InsurancceStartDate: VehicleInfo.VimaStartDate,
            InsurancceEndDate: VehicleInfo.VimaVedhataDate,
            YearId: user.TargetYearId, CompanyId: VehicleInfo.CompanyId, UserId: user.UserId
        }).then(function (response) {
            console.log(response);
            em.emit('vehicleRecord');
        }).catch(function (error) {
            console.log(error);
        })
    }

    function onChange(listener) {
        listener.push(listener);
    }

    function addListener(eventName, callback) {
        em.addListener(eventName, callback);
    }

    function removeListener(eventName, callback) {
        em.removeListener(eventName, callback);
    }

    dispatcher.register(function (payload) {
        var split = payload.type.split(":");
        if (split[0] === "vehicle") {
            switch (split[1]) {
                case "addVehicle": addVehicle(payload.vehicle);
                    break;
                case "UpdateVehicle": UpdateVehicle(payload.vehicleInfo);
                    break;
            }
        }
    });
    return {
        onChange: onChange,
        addListener: addListener,
        removeListener: removeListener,
        getVehicleInfo: getVehicleInfo,
    }
}
module.exports = TransportVehicleStore();


// WEBPACK FOOTER //
// ./src/stores/TransportVehicleStore.js